<template><svg width="512px" height="512px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
    <circle cx="256" cy="256" r="26" style="fill:#ddd;"/>
    <circle cx="256" cy="346" r="26" style="fill:#ddd;"/>
    <circle cx="256" cy="166" r="26" style="fill:#ddd;"/>
    <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
        style="fill:none;stroke:#ddd;stroke-miterlimit:10;stroke-width:32px"/>
</svg></template>